<script>
    export default {
        name: "SkeletonTextPage",
    };
</script>

<template>
    <div class="skeleton-text-page">
        <div class="skeleton-text-page__left">
            <div class="skeleton-text-page__header skeleton-animation"></div>
            <div class="skeleton-text-page__body skeleton-animation"></div>
        </div>
        <div class="skeleton-text-page__right">
            <div class="skeleton-text-page__header skeleton-animation"></div>
            <div class="skeleton-text-page__body skeleton-animation"></div>
        </div>
    </div>
</template>

<style lang="scss">
    @import "style";

    .skeleton-text-page {
        width: 100%;

        @include bp($bp-desktop-sm) {
            display: flex;
            align-items: flex-start;
        }
    }

    .skeleton-text-page__header {
        height: 40px;
        margin-bottom: 16px;
        border-radius: var(--service-border-radius);
        @include bp($bp-desktop-sm) {
            max-width: 50%;
            margin-bottom: 40px;
        }
    }

    .skeleton-text-page__body {
        padding-bottom: 60%;
        border-radius: var(--service-border-radius);
    }

    .skeleton-text-page__left {
        min-height: 200px;
        margin-bottom: 40px;

        @include bp($bp-desktop-sm) {
            width: calc(58.5% - 38px);
            min-height: 500px;
            margin-bottom: 0;
            margin-right: 38px;
        }
    }

    .skeleton-text-page__right {
        min-height: 200px;
        border-radius: var(--service-border-radius);
        @include bp($bp-desktop-sm) {
            flex-grow: 1;
            min-height: 300px;
        }
    }
</style>
